import React from "react";
import {OTHER_GROUP_COLOR, OTHER_GROUP_LABEL} from "./format.js";

const FREE_COLOR = "#f1f3f5";
const FREE_BORDER = "#adb5bd";

/**
 * Legende der Warengruppen-Farben für die Lagerplätze-Grafik - dieselbe
 * feste Palette wie im Rest der Verkaufsstatistik (siehe format.js).
 * Beschriftung ist Pflicht: Farbe allein trägt hier nie die Information
 * (siehe globale Vorgabe zu Diagrammen), deshalb steht neben jeder Farbe
 * immer der Name der Warengruppe.
 */
export default function LagerplaetzeLegend({colorMap, groupsPresent, hasOther}) {
    const entries = (groupsPresent || []).filter((name) => colorMap[name]).map((name) => ({label: name, color: colorMap[name]}));
    if (hasOther) {
        entries.push({label: OTHER_GROUP_LABEL, color: OTHER_GROUP_COLOR});
    }

    return (
        <div className="d-flex flex-wrap align-items-center gap-3 small">
            {entries.map((entry) => (
                <span key={entry.label} className="d-inline-flex align-items-center gap-1">
                    <span
                        aria-hidden="true"
                        style={{width: 12, height: 12, borderRadius: 3, backgroundColor: entry.color, display: "inline-block"}}
                    />
                    {entry.label}
                </span>
            ))}
            <span className="d-inline-flex align-items-center gap-1 text-muted">
                <span
                    aria-hidden="true"
                    style={{
                        width: 12,
                        height: 12,
                        borderRadius: 3,
                        backgroundColor: FREE_COLOR,
                        border: `1px dashed ${FREE_BORDER}`,
                        display: "inline-block",
                    }}
                />
                Freie Regalreihenmeter
            </span>
            <span className="d-inline-flex align-items-center gap-1 text-muted">
                <span
                    aria-hidden="true"
                    style={{
                        width: 12,
                        height: 12,
                        borderRadius: 3,
                        backgroundColor: "#ffffff",
                        backgroundImage:
                            "repeating-linear-gradient(45deg, #ced4da 0, #ced4da 1px, transparent 1px, transparent 4px)",
                        border: "1px solid #dee2e6",
                        display: "inline-block",
                    }}
                />
                Gänge und Verkehrsfläche
            </span>
            <span className="d-inline-flex align-items-center gap-1 text-muted">
                <span
                    aria-hidden="true"
                    style={{width: 12, height: 12, borderRadius: 3, backgroundColor: "#fff3cd", border: "1px solid #e0b400", display: "inline-block"}}
                />
                Wareneingang/-ausgang
            </span>
        </div>
    );
}
